"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiKitBase = exports.UiKitRedAsterisk = exports.UiKitTooltip = exports.UiKitCollapsible = exports.UiKitFormLabelLeft = exports.UiKitStatusIcon = exports.Sections = void 0;
const react_1 = require("@chakra-ui/react");
const UiKitFunctions_1 = require("./UiKitFunctions");
const UiKitNavigation_1 = require("./UiKitNavigation");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_2 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const UiKitIcons_1 = require("./UiKitIcons");
const icons_1 = require("@chakra-ui/icons");
const faChevronDown_1 = require("@fortawesome/free-solid-svg-icons/faChevronDown");
const faChevronUp_1 = require("@fortawesome/free-solid-svg-icons/faChevronUp");
const UiKitButton_1 = require("./components/UiKitButton");
const consistency_1 = require("./consistency");
const UiKitSelect_1 = require("./components/UiKitSelect");
const UiKitInput_1 = require("./components/UiKitInput");
const UiKitDatePicker_1 = require("./components/UiKitDatePicker");
const UiKitContext_1 = require("./UiKitContext");
const color_1 = require("./color");
const UiKitNav_1 = require("./components/UiKitNav/UiKitNav");
const UiKitTabs_1 = require("./components/UiKitTabs/UiKitTabs");
const UiKitStatusTheme_1 = require("./UiKitStatusTheme");
var UiKitNav_2 = require("./components/UiKitNav/UiKitNav");
Object.defineProperty(exports, "Sections", { enumerable: true, get: function () { return UiKitNav_2.Sections; } });
const UiKitBoxStyle = {
    backgroundColor: consistency_1.consistency.white,
    padding: consistency_1.consistency.buffer,
    border: `1px solid ${consistency_1.consistency.gray11110}`,
    borderRadius: consistency_1.consistency.borderRadius,
    boxShadow: '0px 0px 1px rgba(17, 47, 78, 0.24)',
};
const UiKitBlueBoxStyle = {
    backgroundColor: consistency_1.consistency.primaryBlue05,
    padding: consistency_1.consistency.buffer,
    border: `1px solid ${consistency_1.consistency.primaryBlue50}`,
    borderRadius: consistency_1.consistency.borderRadius,
    boxShadow: '0px 0px 1px rgba(17, 47, 78, 0.24)',
};
const UiKitGreenBoxStyle = {
    backgroundColor: consistency_1.consistency.success05,
    padding: consistency_1.consistency.buffer,
    border: `1px solid ${consistency_1.consistency.success50}`,
    borderRadius: consistency_1.consistency.borderRadius,
    boxShadow: '0px 0px 1px rgba(17, 47, 78, 0.24)',
};
const preventEventPropagation = (evt, action) => {
    if (!evt) {
        evt = window.event;
    }
    evt.stopPropagation();
    action?.();
};
const UiKitBoxWithHeader = ({ headerColor, headerPaddingY = '5px', headerPaddingX = consistency_1.consistency.buffer, header, children, headerProps = {}, ...rest }) => {
    const { backgroundColor, border, ...infoBoxStyle } = UiKitBoxStyle;
    let headerJsx = header;
    if (typeof header === 'string') {
        headerJsx = react_2.default.createElement(UiKitTextBodySmall, null, header);
    }
    return (react_2.default.createElement(react_1.Stack, { align: 'stretch', width: '100%', justify: 'flex-start', bg: backgroundColor, style: {
            border: `1px solid ${headerColor}`,
            ...infoBoxStyle,
        }, spacing: 0, ...rest },
        react_2.default.createElement(react_1.Stack, { bg: headerColor, margin: `-${headerPaddingX} 0 ${headerPaddingX} -${headerPaddingX}`, paddingY: headerPaddingY, paddingX: headerPaddingX, w: `calc(100% + (2 * ${headerPaddingX}))`, ...headerProps }, headerJsx),
        children));
};
const UiKitInfoBox = (props) => {
    const { backgroundColor, ...infoBoxStyle } = props.highlight
        ? props.highlight === 'green'
            ? UiKitGreenBoxStyle
            : UiKitBlueBoxStyle
        : UiKitBoxStyle;
    const banner = props.banner;
    if (banner) {
        infoBoxStyle['position'] = 'relative';
        infoBoxStyle['overflow'] = 'hidden';
    }
    if (props.isTransparent) {
        infoBoxStyle['padding'] = '0';
        infoBoxStyle['border'] = 'none';
    }
    if (props.leftHighlight) {
        infoBoxStyle['borderLeft'] = `4px solid ${props.leftHighlight}`;
    }
    const errorTheme = (0, UiKitStatusTheme_1.getStatusTheme)('error');
    const bannerJSX = (react_2.default.createElement("span", { style: {
            border: `1px solid ${props.isInternal ? errorTheme.highlightColor : consistency_1.consistency.primaryBlue50}`,
            backgroundColor: props.isInternal ? errorTheme.backgroundColor : consistency_1.consistency.white,
            color: props.isInternal ? errorTheme.highlightColor : consistency_1.consistency.gray90,
            letterSpacing: '1px',
            textTransform: 'uppercase',
            fontSize: '10px',
            display: 'block',
            textAlign: 'center',
            position: 'absolute',
            right: -55,
            top: 30,
            justifyContent: 'center',
            transform: 'rotate(45deg)',
            width: '200px',
            height: '26px',
            lineHeight: '26px',
        } }, banner || ''));
    return (react_2.default.createElement(react_1.Stack, { align: 'stretch', width: props.width, justify: 'flex-start', style: { ...infoBoxStyle, ...props.style }, bg: props.isTransparent ? 'transparent' : backgroundColor, spacing: 0, flex: props.flex, onClick: props.onClick, position: props.position, _hover: props.onClick
            ? {
                backgroundColor: consistency_1.consistency.gray01,
                cursor: 'pointer',
            }
            : undefined },
        banner && bannerJSX,
        props.title && (react_2.default.createElement(react_1.HStack, { justify: "space-between", align: "center", style: {
                padding: `${consistency_1.consistency.buffer} ${consistency_1.consistency.buffer}`,
                margin: `-${consistency_1.consistency.buffer} -${consistency_1.consistency.buffer}
              ${consistency_1.consistency.buffer} -${consistency_1.consistency.buffer}`,
                borderBottom: `1px solid ${props.isNote ? consistency_1.consistency.warning50 : 'transparent'}`,
                borderTopLeftRadius: consistency_1.consistency.borderRadius,
                borderTopRightRadius: consistency_1.consistency.borderRadius,
            } },
            react_2.default.createElement(react_1.HStack, { align: 'center', spacing: consistency_1.consistency.buffer },
                props.title && react_2.default.createElement(exports.UiKitBase.Text.Heading3, { text: props.title }),
                props.site && (react_2.default.createElement("span", null,
                    "Current Site",
                    react_2.default.createElement("span", { style: {
                            marginLeft: consistency_1.consistency.buffer,
                            fontStyle: 'italic',
                        } }, props.site))),
                props.componentAfterTitle ? props.componentAfterTitle : react_2.default.createElement(react_2.default.Fragment, null)),
            props.componentAtEnd ? props.componentAtEnd : react_2.default.createElement(react_2.default.Fragment, null))),
        react_2.default.createElement(react_1.VStack, { spacing: consistency_1.consistency.buffer, align: "stretch" },
            props.isInternal && (react_2.default.createElement(react_1.Box, { m: '-12px' },
                react_2.default.createElement(exports.UiKitBase.Hint.Tip, { textLines: ['Internal Only'], colored: true }))),
            props.tooltipLines && react_2.default.createElement(exports.UiKitBase.Hint.Info, { textLines: props.tooltipLines }),
            props.children && props.children)));
};
const UiKitTextClickable = (props) => {
    const useNewBranding = (0, react_2.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const brandColor = useNewBranding ? color_1.brandColors.link.font : consistency_1.consistency.primaryBlue50;
    const link = (react_2.default.createElement(react_1.Link, { color: props.color ?? brandColor, onClick: props.onClick, fontSize: '14px', "data-cy": props.dataCy, lineHeight: '20px', style: { textDecoration: props.underline ? '' : 'none' }, title: props.title, _hover: {
            textDecoration: 'underline',
        } }, props.text));
    if (props.showPrecedingLeftArrow) {
        return (react_2.default.createElement(react_1.HStack, { align: "center", spacing: 1 },
            react_2.default.createElement(icons_1.ArrowBackIcon, { w: 3, h: 3, color: brandColor }),
            link));
    }
    else if (props.showProcedingRightArrow) {
        return (react_2.default.createElement(react_1.HStack, { align: "center", spacing: 1 },
            link,
            react_2.default.createElement(icons_1.ArrowForwardIcon, { w: 3, h: 3, color: brandColor })));
    }
    else if (props.icon) {
        return (react_2.default.createElement(react_1.HStack, { align: "center", spacing: 1 },
            props.icon,
            link));
    }
    return link;
};
// TODO: External links should not be underlined, and should be appended with the external icon
const UiKitTextClickableExternalLink = (props) => {
    const useNewBranding = (0, react_2.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    return (react_2.default.createElement(react_1.Link, { color: useNewBranding ? color_1.brandColors.link.font : consistency_1.consistency.primaryBlue50, href: props.href, style: { textDecoration: 'underline' }, isExternal: true }, props.text));
};
const UiKitTextBreadcrumb = (props) => {
    const elements = [];
    props.items.forEach((item, idx) => {
        if (item.onClick) {
            elements.push(react_2.default.createElement(UiKitTextClickable, { key: `breadcrumb-element-${idx}`, text: item.label, dataCy: item.dataCy, onClick: item.onClick }));
        }
        else {
            elements.push(react_2.default.createElement(UiKitTextBodyRegular, { key: `breadcrumb-element-${idx}` }, item.label));
        }
        if (idx !== props.items.length - 1) {
            elements.push(react_2.default.createElement(icons_1.ChevronRightIcon, { key: `breadcrumb-chevron-${idx}`, color: consistency_1.consistency.gray50 }));
        }
    });
    return (react_2.default.createElement(react_1.HStack, { align: 'center', spacing: consistency_1.consistency.halfBuffer }, elements));
};
const UiKitItemsNumberBadge = (props) => {
    return (react_2.default.createElement(react_1.Badge, { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#DFE1E2',
            borderRadius: '20px',
        } },
        react_2.default.createElement(UiKitTextBodySmall, null,
            react_2.default.createElement("b", null, props.children))));
};
const UiKitFormRadioGroup = (props) => (react_2.default.createElement(react_1.RadioGroup, { onChange: props.onChange, value: props.value },
    react_2.default.createElement(react_1.VStack, { align: 'flex-start' }, props.options.map((option, idx) => (react_2.default.createElement(react_1.VStack, { spacing: 0, alignItems: 'flex-start', key: `Radio-${idx}` },
        react_2.default.createElement(react_1.HStack, null,
            react_2.default.createElement(UiKitFormRadio, { text: option.text, value: option.value, isDisabled: option.isDisabled, isChecked: option.isChecked, textSize: option.textSize }),
            option.tagText && (react_2.default.createElement(exports.UiKitBase.Tag.Custom, { backgroundColor: consistency_1.consistency.primaryBlue05, borderColor: consistency_1.consistency.primaryBlue05, noBorder: true, textColor: consistency_1.consistency.primaryBlue40, text: 'Recommended' })),
            option.customTagText && (react_2.default.createElement(exports.UiKitBase.Tag.Custom, { backgroundColor: consistency_1.consistency.primaryBlue05, borderColor: consistency_1.consistency.primaryBlue05, noBorder: true, textColor: consistency_1.consistency.primaryBlue40, text: option.customTagText }))),
        option.helpText && (react_2.default.createElement(react_1.HStack, { pl: consistency_1.consistency.largeBuffer },
            react_2.default.createElement(UiKitTextBodySmall, { color: consistency_1.consistency.gray70 }, option.helpText))),
        option.componentAfterHelpText && (react_2.default.createElement(react_1.HStack, { pl: consistency_1.consistency.largeBuffer }, option.componentAfterHelpText))))))));
const UiKitFormRadio = (props) => {
    let textDisplay;
    if (props.textSize === 'small') {
        textDisplay = react_2.default.createElement(UiKitTextBodySmall, null, props.text);
    }
    else if (props.textSize === 'regular') {
        textDisplay = react_2.default.createElement(UiKitTextBodyRegular, null, props.text);
    }
    else {
        textDisplay = props.text;
    }
    return (react_2.default.createElement(react_1.Radio, { isDisabled: props.isDisabled, value: props.value, borderColor: consistency_1.consistency.gray10, isChecked: props.isChecked, _checked: {
            borderColor: consistency_1.consistency.primaryBlue50,
            borderWidth: consistency_1.consistency.borderRadius,
        }, cursor: 'pointer' }, textDisplay));
};
const UiKitStatusIcon = (props) => {
    const useNewBranding = (0, react_2.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const statusTheme = (0, UiKitStatusTheme_1.getStatusTheme)(props.status);
    const width = props.isSmall ? '14px' : '20px';
    const height = props.isSmall ? '14px' : '20px';
    const color = props.color || (useNewBranding ? statusTheme.textColor : statusTheme.highlightColor);
    return (react_2.default.createElement(react_1.Icon, { width: width, height: height, viewBox: '0 0 20 20', color: color, alignContent: 'center' }, statusTheme.icon));
};
exports.UiKitStatusIcon = UiKitStatusIcon;
const UiKitHint = (props) => {
    const [isRemoved, setIsRemoved] = (0, react_2.useState)(false);
    const useNewBranding = (0, react_2.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    const style = {
        ...UiKitBoxStyle,
        padding: props.noBorder
            ? undefined
            : `${consistency_1.consistency.buffer} ${consistency_1.consistency.buffer} ${consistency_1.consistency.buffer} 0`,
        alignItems: 'stretch',
        width: '100%',
        border: props.noBorder ? 'none' : UiKitBoxStyle.border,
    };
    if (props.colored) {
        const statusTheme = (0, UiKitStatusTheme_1.getStatusTheme)(props.status);
        style.backgroundColor = statusTheme.backgroundColor;
        style.border = props.noBorder ? 'none' : `1px solid ${statusTheme.highlightColor}`;
        style.color = statusTheme.textColor;
    }
    const iconWidth = '45px';
    const detail = (react_2.default.createElement(react_1.VStack, { spacing: consistency_1.consistency.buffer, align: 'stretch', justify: 'flex-start', pl: props.title ? iconWidth : 0 },
        props.textLines?.map((line, index) => {
            return (react_2.default.createElement(react_1.Text, { key: index, m: '0', textTransform: 'none' }, line));
        }),
        props.children));
    const header = props.title && (react_2.default.createElement(react_1.HStack, { align: 'center', justify: 'space-between', flex: 1 },
        react_2.default.createElement(react_1.Text, { fontSize: '18px', lineHeight: '18px', fontWeight: '400', color: useNewBranding ? '' : consistency_1.consistency.gray80, m: "0" }, props.title),
        props.removable && (react_2.default.createElement(react_1.CloseButton, { size: 'xs', _hover: {
                backgroundColor: 'transparent',
            }, backgroundColor: "transparent", onClick: () => setIsRemoved(true) }))));
    return !isRemoved ? (react_2.default.createElement(react_1.VStack, { style: style, justify: 'flex-start' },
        react_2.default.createElement(react_1.HStack, { justify: 'flex-start', align: 'flex-start', width: '100%', spacing: 0 },
            react_2.default.createElement(react_1.HStack, { minW: iconWidth, w: iconWidth, align: 'center', justify: 'center' },
                react_2.default.createElement(exports.UiKitStatusIcon, { status: props.status })),
            header,
            !props.title && detail),
        props.title && detail)) : (react_2.default.createElement(react_2.default.Fragment, null));
};
const UiKitHintForStatus = (status, props) => (react_2.default.createElement(UiKitHint, { status: status, title: props.title, textLines: props.textLines, colored: props.colored, removable: props.removable, noBorder: props.noBorder }, props.children));
const UiKitTableHeader = (props) => {
    return (react_2.default.createElement("thead", null,
        react_2.default.createElement("tr", null, props.columns.map((column, idx) => {
            return (react_2.default.createElement("th", { style: {
                    padding: `${consistency_1.consistency.halfBuffer}`,
                    backgroundColor: props.backgroundColor ? props.backgroundColor : '#fff',
                    borderTop: `1px solid ${consistency_1.consistency.gray11110}`,
                    borderBottom: `1px solid ${consistency_1.consistency.gray11110}`,
                    textAlign: 'left',
                }, key: `header-${idx}` },
                react_2.default.createElement(react_1.VStack, { spacing: "0px", alignItems: props.alignments === undefined ? 'start' : props.alignments[idx] },
                    typeof column === 'string' ? react_2.default.createElement(UiKitTextBodyRegular, null, column) : column,
                    react_2.default.createElement(UiKitTextBodyExtraSmall, null, props.subHeaders === undefined ? '' : props.subHeaders[idx]))));
        }))));
};
const UiKitTableRow = (props) => {
    const hasClickHandler = !!props.clickHandler;
    // Here we 'useMemo' otherwise the Row is re-created on every iteration,
    // effectively re-rendering itself and all children
    const Row = (0, react_2.useMemo)(() => hasClickHandler
        ? (0, styled_1.default)('tr') `
            :hover {
              color: ${consistency_1.consistency.primaryBlue50};
              background: linear-gradient(#fcfcfc, #f9f9f9);
              cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
            }
          `
        : (0, styled_1.default)('tr') ``, [hasClickHandler, props.disabled]);
    const clickHandlerExcludedCells = props.clickHandlerExcludedCells || [];
    const cellPadding = props.cellPadding ?? `8px ${consistency_1.consistency.halfBuffer}`;
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(Row, { style: {
                // TODO: check if we really need these different props for the styling.
                borderBottom: !props.expandedContent ? `1px solid ${consistency_1.consistency.gray11110}` : undefined,
                opacity: props.disabled ? 0.6 : 1,
                position: props.relativePosition ? 'relative' : undefined,
            } }, props.children.map((child, idx) => {
            return (react_2.default.createElement("td", { onClick: !clickHandlerExcludedCells.includes(idx) && props.clickHandler && !props.disabled
                    ? props.clickHandler
                    : undefined, style: {
                    verticalAlign: 'center',
                    padding: cellPadding,
                    backgroundColor: props.backgroundColors
                        ? props.backgroundColors[idx]
                        : props.backgroundColor
                            ? props.backgroundColor
                            : 'transparent',
                    width: 'auto',
                }, key: `cell-${idx}` }, child));
        })),
        props.expandedContent && (react_2.default.createElement(Row, { style: {
                borderBottom: `1px solid ${consistency_1.consistency.gray11110}`,
                opacity: props.disabled ? 0.6 : 1,
            } },
            react_2.default.createElement("td", { style: {
                    backgroundColor: props.backgroundColor ? props.backgroundColor : consistency_1.consistency.white,
                }, colSpan: props.children.length }, props.expandedContent)))));
};
const UiKitTable = (props) => {
    if (props.data.length === 0 && props.noDataMessage !== undefined) {
        return react_2.default.createElement(UiKitHint, { status: 'warning outline', textLines: [props.noDataMessage] });
    }
    const showHeaderRow = props.headers.filter(header => ('text' in header && !!header.text) || ('content' in header && !!header.content)).length !== 0;
    const subheaders = props.headers.map(header => header.subheader || '');
    return (react_2.default.createElement(react_1.Table, { variant: 'striped', style: {
            width: '100%',
            textAlign: 'left',
            borderCollapse: 'collapse',
        } },
        react_2.default.createElement("colgroup", null, props.headers.map((header, i) => (react_2.default.createElement("col", { key: i, style: {
                width: header.width,
                minWidth: header.width === 'auto' ? undefined : header.width,
            } })))),
        showHeaderRow && (react_2.default.createElement(UiKitTableHeader, { columns: props.headers.map((header, index) => (react_2.default.createElement(react_1.HStack, { key: `th-${index}`, align: 'center', spacing: consistency_1.consistency.halfBuffer },
                'text' in header && react_2.default.createElement(UiKitTextBodyRegular, null, header.text),
                'content' in header && header.content,
                header.infoTooltip && (react_2.default.createElement(exports.UiKitBase.Tooltip, { tooltip: header.infoTooltip, status: 'info outline', placement: 'right' }))))), backgroundColor: consistency_1.consistency.gray02, ...(subheaders.some(x => x !== '') && { subHeaders: subheaders }) })),
        react_2.default.createElement(react_1.Tbody, null, props.data !== undefined &&
            props.data.map((row, idx) => (react_2.default.createElement(UiKitTableRow, { key: 'key' in row ? row.key : idx, cellPadding: props.cellPadding, ...('rowProps' in row ? row.rowProps : {}) }, 'cells' in row ? row.cells : row))))));
};
const UiKitMenuItem = (props) => {
    const item = props.item;
    return (react_2.default.createElement(react_1.MenuItem, { backgroundColor: consistency_1.consistency.white, _hover: { bg: consistency_1.consistency.gray04, color: consistency_1.consistency.gray90 }, _selected: { bg: consistency_1.consistency.gray04, color: consistency_1.consistency.gray90 }, _focus: { bg: consistency_1.consistency.gray04, color: consistency_1.consistency.gray90 }, _active: { bg: consistency_1.consistency.gray04, color: consistency_1.consistency.gray90 }, fontSize: '14px', lineHeight: '24px', key: item.text, icon: item.icon, onClick: evt => preventEventPropagation(evt, item.onClick), color: item.color || consistency_1.consistency.gray90, isDisabled: item.disabled || false, "data-cy": item.dataCy },
        react_2.default.createElement(react_1.Text, { m: '0', fontSize: '14px', color: item.textColor }, item.text)));
};
const UiKitIcon = (props) => {
    return (react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { onClick: props.onClick, cursor: props.onClick ? 'pointer' : 'auto', icon: props.fontAwesomeIcon, color: props.color ?? consistency_1.consistency.gray90 }));
};
const UiKitDotsMenu = (props) => {
    return (react_2.default.createElement(react_1.Menu, null,
        react_2.default.createElement(react_1.MenuButton, { colorScheme: 'white', backgroundColor: '#FCFCFC', border: 'none', as: react_1.IconButton, size: 'sm', "aria-label": "Options", _hover: {
                backgroundColor: consistency_1.consistency.gray11110,
            }, icon: react_2.default.createElement(UiKitIcons_1.UiKitIcons.Global.More, null), variant: "outline", onClick: evt => preventEventPropagation(evt), "data-cy": 'btn-dots-menu' }),
        react_2.default.createElement(react_1.MenuList, { border: `1px solid ${consistency_1.consistency.gray11000}`, borderRadius: '3px', p: '0', m: '0', boxShadow: `0px 0px ${consistency_1.consistency.buffer} 2px ${consistency_1.consistency.gray11000}` }, props.options.map(item => {
            return react_2.default.createElement(UiKitMenuItem, { key: item.text, item: item });
        }))));
};
const UiKitMenuTertiary = (props) => (react_2.default.createElement(react_1.Menu, null,
    react_2.default.createElement(react_1.MenuButton, { as: react_1.Button, bgColor: 'white', color: consistency_1.consistency.primaryBlue50, _hover: { backgroundColor: 'white', color: consistency_1.consistency.primaryBlue40 }, _selected: { bg: 'white' }, _focus: { bg: 'white' }, _active: { bg: 'white' }, leftIcon: props.leftIcon }, props.text),
    react_2.default.createElement(react_1.MenuList, { border: `1px solid ${consistency_1.consistency.gray11000}`, style: {
            maxHeight: '800px',
            overflowY: 'auto',
            zIndex: 5000,
        }, borderRadius: '3px', boxShadow: `0px 0px ${consistency_1.consistency.buffer} 2px ${consistency_1.consistency.gray11000}` }, props.options.map(item => {
        return react_2.default.createElement(UiKitMenuItem, { key: item.text, item: item });
    }))));
const UiKitMenu = (props) => {
    return (react_2.default.createElement(react_1.Box, null,
        react_2.default.createElement(react_1.Menu, null,
            react_2.default.createElement(react_1.MenuButton, { bgColor: consistency_1.consistency.primaryBlue50, pl: '16px', pr: '16px', color: consistency_1.consistency.white, _hover: { bg: consistency_1.consistency.primaryBlue50 }, _selected: { bg: consistency_1.consistency.primaryBlue50 }, _focus: { bg: consistency_1.consistency.primaryBlue50 }, _active: { bg: consistency_1.consistency.primaryBlue50 }, border: 'none', "aria-label": "Options", variant: "outline", as: react_1.Button, leftIcon: props.leftIcon, rightIcon: react_2.default.createElement(UiKitIcon, { fontAwesomeIcon: faChevronDown_1.faChevronDown, color: consistency_1.consistency.white }) }, props.text),
            react_2.default.createElement(react_1.MenuList, { border: `1px solid ${consistency_1.consistency.gray11000}`, style: {
                    maxHeight: '800px',
                    overflowY: 'auto',
                    zIndex: 5000,
                }, borderRadius: '3px', boxShadow: `0px 0px ${consistency_1.consistency.buffer} 2px ${consistency_1.consistency.gray11000}` }, props.options.map(item => {
                return react_2.default.createElement(UiKitMenuItem, { key: item.text, item: item });
            })))));
};
const UiKitTextStatusIconAndText = (props) => (react_2.default.createElement(react_1.HStack, { spacing: '5px' },
    react_2.default.createElement(exports.UiKitStatusIcon, { status: props.status }),
    typeof props.text === 'string' ? react_2.default.createElement(UiKitTextBodyRegular, null, props.text) : props.text));
const UiKitTextDashDash = () => (react_2.default.createElement(UiKitTextBodyRegular, { color: consistency_1.consistency.gray50 }, "--"));
const UiKitTagForStatus = (props) => {
    const statusTheme = (0, UiKitStatusTheme_1.getStatusTheme)(props.status);
    return (react_2.default.createElement(UiKitTag, { backgroundColor: statusTheme.backgroundColor, showIcon: props.showIcon ? props.status : undefined, borderColor: statusTheme.highlightColor, isClosable: props.isClosable, text: props.text ?? statusTheme.label, isSmall: props.isSmall, onCloseClick: props.onCloseClick, textColor: statusTheme.textColor }));
};
const UiKitTagNew = () => (react_2.default.createElement(UiKitTag, { backgroundColor: consistency_1.consistency.info05, textColor: consistency_1.consistency.info50, borderColor: consistency_1.consistency.info50, text: 'New' }));
const UiKitTagBeta = () => (react_2.default.createElement(UiKitTag, { backgroundColor: consistency_1.consistency.warning05, textColor: consistency_1.consistency.warning70, borderColor: consistency_1.consistency.warning50, text: 'Beta' }));
const UiKitTag = (props) => {
    const borderColor = props.noBorder === true ? props.backgroundColor : props.borderColor;
    const [isRemoved, setIsRemoved] = (0, react_2.useState)(false);
    if (isRemoved) {
        return null;
    }
    return (react_2.default.createElement(react_1.HStack, { align: 'center', border: `1px solid ${borderColor}`, backgroundColor: props.backgroundColor, padding: props.isSmall ? '1px 4px' : '2px 8px', borderRadius: consistency_1.consistency.borderRadius },
        props.showIcon && !props.customIconString && (react_2.default.createElement(exports.UiKitStatusIcon, { status: props.showIcon, isSmall: true })),
        !props.showIcon && props.customIconString && (react_2.default.createElement(react_1.Icon, { width: '20px', height: '20px', viewBox: '0 0 20 20', color: props.customIconColor },
            react_2.default.createElement(UiKitIcons_1.UiKitIcons.Global.Overlap, null))),
        react_2.default.createElement(react_1.Text, { color: props.textColor ?? consistency_1.consistency.gray70, fontSize: props.isSmall ? '12px' : '14px', m: '0px', fontWeight: props.fontWeight ?? 400, noOfLines: props.noOfLines, maxWidth: props.maxWidth }, props.text),
        props.isClosable && (react_2.default.createElement(react_1.Icon, { width: '12px', height: '12px', viewBox: '0 0 20 20', color: consistency_1.consistency.gray70, alignContent: 'center', cursor: 'pointer', onClick: () => {
                setIsRemoved(true);
                if (props.onCloseClick) {
                    props.onCloseClick();
                }
            } },
            react_2.default.createElement(UiKitIcons_1.UiKitIcons.Global.Close, null)))));
};
const BodyText = (props) => {
    return (react_2.default.createElement(react_1.Text, { fontSize: props.fontSize, lineHeight: props.lineHeight, fontWeight: props.fontWeight ?? '400', color: props.color ? props.color : consistency_1.consistency.gray90, display: 'inline', m: "0", id: props.id, backgroundColor: props.backgroundColor, style: props.style }, props.children));
};
const UiKitTextBodyLarge = (props) => (react_2.default.createElement(BodyText, { fontSize: '18px', lineHeight: '22px', fontWeight: '500', color: props.color }, props.children));
const UiKitTextBodyLargeWithBackground = (props) => (react_2.default.createElement(BodyText, { fontSize: '30px', lineHeight: '22px', fontWeight: '500', color: props.color, backgroundColor: props.backgroundColor }, props.children));
const UiKitTextBodyRegular = (props) => (react_2.default.createElement(BodyText, { fontSize: '14px', lineHeight: '20px', color: props.color, id: props.id }, props.children));
const UiKitTextBodyRegularBold = (props) => (react_2.default.createElement(BodyText, { fontSize: '14px', lineHeight: '20px', color: props.color, fontWeight: '600' }, props.children));
const UiKitTextBodySemiBold = (props) => (react_2.default.createElement(BodyText, { fontSize: '14px', lineHeight: '20px', color: props.color, fontWeight: '400' }, props.children));
const UiKitTextBodySmall = (props) => (react_2.default.createElement(BodyText, { fontSize: '12px', lineHeight: '18px', color: props.color, style: props.style }, props.children));
const UiKitTextBodyExtraSmall = (props) => (react_2.default.createElement(BodyText, { fontSize: '10px', lineHeight: '16px', color: props.color }, props.children));
const UiKitTextInactiveLink = (props) => {
    return (react_2.default.createElement(react_1.Text, { fontSize: '16px', lineHeight: '20px', fontWeight: 'normal', fontStyle: 'normal', color: consistency_1.consistency.primaryBlue20, m: "0" }, props.children));
};
const UiKitFormLabelLeft = (props) => {
    const isArray = props.content instanceof Array;
    const StackComponent = props.isVertical ? react_1.VStack : react_1.HStack;
    const content = isArray
        ? props.content.map((word, i) => {
            return (react_2.default.createElement(react_2.default.Fragment, null,
                i > 0 && !props.isVertical && (react_2.default.createElement(UiKitTextBodyRegular, { key: `${i}-comma` }, ",\u00A0")),
                react_2.default.createElement(UiKitTextBodyRegular, { key: `${i}-word` }, word)));
        })
        : props.content;
    return (react_2.default.createElement(react_2.default.Fragment, null, (isArray ? props.content.length > 0 : true) && (react_2.default.createElement(react_1.HStack, { align: props.isVertical ? 'flex-start' : 'center' },
        props.title && (react_2.default.createElement(react_1.HStack, { align: 'center', minW: '140px' },
            react_2.default.createElement(UiKitTextBodyRegular, { color: consistency_1.consistency.gray60 }, props.title))),
        react_2.default.createElement(StackComponent, { flex: 1, align: props.isVertical ? 'stretch' : 'center', spacing: props.isVertical ? '5px' : 0 }, content)))));
};
exports.UiKitFormLabelLeft = UiKitFormLabelLeft;
const UiKitFormLabelText = (props) => (react_2.default.createElement(react_1.HStack, { align: 'center' },
    react_2.default.createElement(UiKitTextBodyRegular, { color: props.color || consistency_1.consistency.gray60 },
        props.label,
        props.showRedAsterisk && (react_2.default.createElement("span", { style: {
                color: consistency_1.consistency.error50,
                fontSize: '20px',
                marginLeft: '2px',
                lineHeight: 0,
            } }, "*"))),
    props.tooltip && (react_2.default.createElement(exports.UiKitTooltip, { tooltip: props.tooltip, status: props.tooltipStatus ?? 'info outline', placement: 'top' }))));
const UiKitFormLabel = (props) => {
    const content = (react_2.default.createElement(react_1.VStack, { pl: props.childIsIndented ? consistency_1.consistency.buffer : 0, align: "stretch", spacing: props.spacing ?? 0, w: '100%' }, props.children));
    return (react_2.default.createElement(react_1.VStack, { spacing: '8px', align: props.childIsFullWidth ? 'stretch' : 'flex-start', width: props.width }, props.collapse ? (react_2.default.createElement(exports.UiKitCollapsible, { status: 'blank', summaryString: props.label, isOpen: props.collapse.initially === 'open', contentWhenClosed: props.collapse.contentWhenClosed }, content)) : (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(UiKitFormLabelText, { label: props.label, tooltip: props.tooltip, tooltipStatus: props.tooltipStatus, showRedAsterisk: props.showRedAsterisk, color: props.color }),
        content))));
};
const UiKitFormCheckbox = (props) => {
    const { isChecked, onChange, isDisabled } = props;
    const defaultColor = isDisabled ? 'blueDisabled' : 'bluePrimary';
    const hoverColor = isDisabled || !isChecked ? defaultColor : 'blueHover';
    const [colorScheme, setColorScheme] = (0, react_2.useState)(defaultColor);
    return (react_2.default.createElement(react_1.Checkbox, { size: props.size, isIndeterminate: props.isIndeterminate, isDisabled: props.isDisabled, isChecked: props.isChecked, background: isDisabled && !isChecked ? consistency_1.consistency.gray02 : 'none', borderRadius: '2px', border: isChecked ? 'none' : `0 solid ${consistency_1.consistency.gray20}`, onChange: event => {
            if (props.isStopPropagation) {
                event.stopPropagation();
            }
            onChange(isChecked);
        }, colorScheme: colorScheme, onMouseEnter: () => setColorScheme(hoverColor), onMouseLeave: () => setColorScheme(defaultColor), "data-cy": props.dataCy, ...props.chakraProps }));
};
const UiKitFormToggle = (props) => (react_2.default.createElement(react_1.Switch, { isChecked: props.isOn, isDisabled: props.isDisabled ?? false, onChange: event => props.onChange(event.target.checked) }));
const UiKitFormRow = (props) => {
    return (react_2.default.createElement(react_1.HStack, { align: 'stretch', mb: consistency_1.consistency.buffer },
        react_2.default.createElement(react_1.Box, { width: props.labelW || '200px', maxW: props.labelW || '200px' },
            react_2.default.createElement(UiKitTextBodyRegular, null, props.label.toUpperCase())),
        react_2.default.createElement(react_1.Box, { m: '0 20px', width: props.componentW || '250px', maxW: props.componentW || '250px' }, props.children),
        react_2.default.createElement(react_1.Box, { flex: 1, color: consistency_1.consistency.gray10000 }, props.hintText)));
};
const UiKitSpinner = () => {
    return (react_2.default.createElement(react_1.Spinner, { thickness: "3px", speed: "0.65s", emptyColor: consistency_1.consistency.gray11110, color: consistency_1.consistency.primaryBlue50 }));
};
const UiKitCollapsible = (props) => {
    const [open, setOpen] = (0, react_2.useState)(props.isOpen ?? false);
    const { useNewBranding } = (0, react_2.useContext)(UiKitContext_1.UiKitContext);
    let statusTheme;
    if (props.status === 'blank') {
        statusTheme = {
            icon: react_2.default.createElement(react_2.default.Fragment, null),
            highlightColor: consistency_1.consistency.gray50,
            backgroundColor: 'transparent',
            textColor: consistency_1.consistency.gray50,
        };
    }
    else {
        statusTheme = (0, UiKitStatusTheme_1.getStatusTheme)(props.status);
    }
    const openCloseHandler = () => {
        const isNowOpen = !open;
        setOpen(isNowOpen);
    };
    const toggleOpenButtonColor = useNewBranding ? statusTheme.textColor : statusTheme.highlightColor;
    const textColor = useNewBranding ? statusTheme.textColor : 'inherit';
    return (react_2.default.createElement(react_1.VStack, { backgroundColor: statusTheme.backgroundColor, borderColor: statusTheme.highlightColor, borderRadius: consistency_1.consistency.borderRadius, align: 'stretch', spacing: 5, width: '100%', borderWidth: props.status === 'blank' ? '0' : '1px', p: props.status === 'blank' ? '0' : consistency_1.consistency.buffer },
        props.status === 'blank' ? (react_2.default.createElement(react_1.HStack, { align: "center", justify: "flex-start", spacing: consistency_1.consistency.halfBuffer, style: { cursor: 'pointer' }, onClick: openCloseHandler },
            react_2.default.createElement(UiKitFormLabelText, { label: props.summaryString }),
            react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: open ? faChevronUp_1.faChevronUp : faChevronDown_1.faChevronDown, color: toggleOpenButtonColor }))) : (react_2.default.createElement(react_1.HStack, { align: "center", justify: "space-between", style: { cursor: 'pointer', color: textColor }, onClick: openCloseHandler },
            react_2.default.createElement(UiKitTextStatusIconAndText, { status: props.status, text: props.summaryString }),
            react_2.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: open ? faChevronUp_1.faChevronUp : faChevronDown_1.faChevronDown, color: toggleOpenButtonColor }))),
        !open && props.contentWhenClosed && react_2.default.createElement("div", { style: { color: textColor } }, props.contentWhenClosed),
        react_2.default.createElement(react_1.Collapse, { in: open, animateOpacity: true, style: { color: textColor } }, props.children)));
};
exports.UiKitCollapsible = UiKitCollapsible;
const UiKitTooltip = (props) => {
    return (react_2.default.createElement(UiKitWrapWithTooltip, { tooltip: props.tooltip, placement: props.placement ?? 'left' },
        react_2.default.createElement(react_1.HStack, { align: "center", width: '20px', justify: 'center' },
            react_2.default.createElement(exports.UiKitStatusIcon, { status: props.status, isSmall: props.isSmall, color: props.color ?? consistency_1.consistency.gray70 }))));
};
exports.UiKitTooltip = UiKitTooltip;
const UiKitWrapWithTooltip = (props) => {
    const tooltips = Array.isArray(props.tooltip)
        ? props.tooltip
        : [props.tooltip];
    const textColor = consistency_1.consistency.white;
    const backgroundColor = consistency_1.consistency.gray80;
    return (react_2.default.createElement(react_1.Tooltip, { label: react_2.default.createElement(react_1.VStack, { spacing: props.spacing ?? consistency_1.consistency.buffer, align: 'stretch' }, tooltips.map((line, idx) => {
            return (react_2.default.createElement(UiKitTextBodyRegular, { color: textColor, key: idx }, line));
        })), "aria-label": tooltips.join(' '), placement: props.placement, borderRadius: consistency_1.consistency.borderRadius, arrowSize: 5, hasArrow: true, bg: backgroundColor, padding: '8px', ...props.chakraProps }, props.children));
};
const UiKitPage = (props) => {
    const useNewBranding = (0, react_2.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    return (react_2.default.createElement(react_1.VStack, { minW: '800px', align: 'stretch', backgroundColor: useNewBranding ? consistency_1.consistency.white : consistency_1.consistency.pageBackground, p: props.padding ?? consistency_1.consistency.buffer, pb: '100px', spacing: consistency_1.consistency.buffer },
        props.children,
        ";"));
};
const UiKitSpinnerWithText = (props) => {
    return (react_2.default.createElement(react_1.VStack, { spacing: 5, align: 'center', mt: props.mt || '200px' },
        react_2.default.createElement(exports.UiKitBase.Spinner, null),
        react_2.default.createElement(exports.UiKitBase.Text.Heading3, { text: props.text })));
};
const UiKitInputLabel = (props) => {
    const astrix = props.isRequired ? react_2.default.createElement(exports.UiKitRedAsterisk, null) : '';
    return (react_2.default.createElement(UiKitTextBodyRegular, null,
        props.text,
        " ",
        astrix));
};
const UiKitInputArea = (props) => {
    return (react_2.default.createElement(react_1.Textarea, { placeholder: props.placeholder, size: props.size ?? 'md', value: props.value, onChange: evt => props.onChange(evt.target.value), borderRadius: consistency_1.consistency.borderRadius, height: props.height ?? '290px', bgColor: consistency_1.consistency.white, borderColor: consistency_1.consistency.gray11100, maxLength: props.maxLength, resize: props.resize ?? 'none', isReadOnly: props.readOnly ?? false, ...props.chakraProps }));
};
const UiKitModal = (props) => {
    const titleRow = props.title && (react_2.default.createElement(react_1.HStack, { justify: 'space-between', align: 'center', width: '100%', bgColor: consistency_1.consistency.gray01, height: '54px', paddingLeft: consistency_1.consistency.buffer, paddingRight: consistency_1.consistency.buffer, boxShadow: `inset 0px -1px 0px ${consistency_1.consistency.gray05}`, borderTopRightRadius: consistency_1.consistency.borderRadius, borderTopLeftRadius: consistency_1.consistency.borderRadius, paddingTop: props.paddingTop, paddingBottom: props.paddingBottom },
        react_2.default.createElement(react_1.HStack, { justify: "flex-start", align: "center", spacing: 2 },
            props.titleLeftIcon,
            react_2.default.createElement(BodyText, { fontSize: '18px', lineHeight: '22px', fontWeight: '600' }, props.title)),
        react_2.default.createElement(react_1.Icon, { width: '20px', height: '20px', viewBox: '0 0 20 20', color: consistency_1.consistency.gray60, alignContent: 'center', cursor: 'pointer', onClick: props.onClose },
            react_2.default.createElement(UiKitIcons_1.UiKitIcons.Global.Close, null))));
    const fullScreen = props.fullScreen !== undefined ? props.fullScreen : false;
    const isCentered = !fullScreen;
    const scrollBehavior = fullScreen ? 'inside' : 'outside';
    return (react_2.default.createElement(react_1.Modal, { autoFocus: props.autoFocus ?? false, isCentered: isCentered, scrollBehavior: scrollBehavior, onClose: props.onClose, isOpen: props.isOpen, size: props.size, closeOnOverlayClick: props.closeOnOverlayClick ?? false, returnFocusOnClose: props.returnFocusOnClose ?? true },
        react_2.default.createElement(react_1.ModalOverlay, null),
        react_2.default.createElement(react_1.ModalContent, { borderRadius: consistency_1.consistency.borderRadius, minH: props.minH, minW: props.minW },
            titleRow,
            react_2.default.createElement(react_1.ModalBody, { p: 0 },
                react_2.default.createElement(react_1.VStack, { align: 'stretch', p: consistency_1.consistency.buffer }, props.bodyFragment)),
            react_2.default.createElement(react_1.ModalFooter, null, props.footerFragment))));
};
const UiKitFormNumber = (props) => {
    return (react_2.default.createElement(react_1.NumberInput, { defaultValue: props.defaultValue, 
        // @ts-expect-error Property placeholder does not exist on type
        placeholder: props.placeholder, min: props.min, max: props.max, onChange: (_, newVal) => props.onChange(newVal), isReadOnly: props.readonly, border: '1px solid transparent', borderRadius: consistency_1.consistency.borderRadius, fontSize: 12, color: consistency_1.consistency.gray70 },
        react_2.default.createElement(react_1.NumberInputField, null),
        react_2.default.createElement(react_1.NumberInputStepper, { border: 'hidden', color: consistency_1.consistency.primaryBlue50 },
            react_2.default.createElement(react_1.NumberIncrementStepper, { border: 'hidden' }),
            react_2.default.createElement(react_1.NumberDecrementStepper, { border: 'hidden' }))));
};
const UiKitNumberInACircleThenText = (props) => {
    return (react_2.default.createElement(react_1.HStack, { align: 'center' },
        react_2.default.createElement(UiKitTabs_1.UiKitNumberInACircle, { number: props.number }),
        react_2.default.createElement(UiKitTextBodyRegular, null, props.text)));
};
const UiKitFilterWithMagnifier = react_2.default.forwardRef((props, ref) => (react_2.default.createElement(react_1.Box, { flexGrow: 1 },
    react_2.default.createElement(react_1.InputGroup, null,
        react_2.default.createElement(react_1.InputLeftElement, { pb: "5px", pl: "4px", width: "36px", pointerEvents: "none" },
            react_2.default.createElement(react_1.Icon, { width: '14px', height: '14px', viewBox: '0 0 14 14' },
                react_2.default.createElement(UiKitIcons_1.UiKitIcons.Global.Magnifier, null))),
        props.value && (react_2.default.createElement(react_1.InputRightElement, { pb: "5px", pl: "4px", width: "36px" },
            react_2.default.createElement(exports.UiKitBase.Button.Cancel, { text: '', leftIcon: 'times', onClick: () => props.handleChange('') }))),
        react_2.default.createElement(react_1.Input, { placeholder: props.placeholder, value: props.value, title: props.title, onChange: e => props.handleChange(e.target.value), "data-cy": `input-${props.filterKey ?? 'input'}`, isDisabled: props.isDisabled, h: "36px", pl: "36px", borderRadius: "4px", fontSize: "14px", ref: ref })))));
const createUiKitHeading = (fontSize, lineHeight, fontWeight) => (props) => (react_2.default.createElement(react_1.Text, { fontSize: fontSize, lineHeight: lineHeight, fontWeight: fontWeight, color: props.colored ? consistency_1.consistency.primaryBlue50 : consistency_1.consistency.gray80, m: '0', ...props.style }, props.text));
const UiKitRedAsterisk = () => (react_2.default.createElement("span", { style: { color: consistency_1.consistency.error50, fontSize: '20px' } }, "*"));
exports.UiKitRedAsterisk = UiKitRedAsterisk;
const UiKitBlob = (props) => {
    const bigCircleRadius = props.outerRadius;
    const smallCircleRadius = props.innerRadius;
    const blobHeight = props.textHeight ? Math.max(props.textHeight / 2, props.outerRadius) : props.outerRadius;
    const diameter = 2 * smallCircleRadius;
    const bigCircleDiameter = 2 * bigCircleRadius;
    const smallCircleWidthOffset = bigCircleRadius - smallCircleRadius;
    const smallCircleHeightOffset = blobHeight - smallCircleRadius;
    const bigCircleHeightOffset = blobHeight - bigCircleRadius;
    const lines = (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Box, { position: 'absolute', left: '0px', top: `${bigCircleRadius - props.sides.lineThickness / 2}px`, w: `${bigCircleRadius}px`, h: `${props.sides.lineThickness}px`, zIndex: 8, background: props.sides.direction === 'horizontal' ? props.sides.prevLineColor : 'transparent' }),
        react_2.default.createElement(react_1.Box, { position: 'absolute', left: `${bigCircleRadius}px`, top: `${bigCircleRadius - props.sides.lineThickness / 2}px`, w: `${bigCircleRadius}px`, h: `${props.sides.lineThickness}px`, zIndex: 8, background: props.sides.direction === 'horizontal' ? props.sides.nextLineColor : 'transparent' }),
        react_2.default.createElement(react_1.Box, { position: 'absolute', left: `${bigCircleRadius - props.sides.lineThickness / 2}px`, top: '0px', w: `${props.sides.lineThickness}px`, h: `${blobHeight}px`, zIndex: 8, background: props.sides.direction === 'vertical' ? props.sides.prevLineColor : 'transparent' }),
        react_2.default.createElement(react_1.Box, { position: 'absolute', left: `${bigCircleRadius - props.sides.lineThickness / 2}px`, top: `${blobHeight}px`, w: `${props.sides.lineThickness}px`, h: `${blobHeight}px`, zIndex: 8, background: props.sides.direction === 'vertical' ? props.sides.nextLineColor : 'transparent' })));
    return (react_2.default.createElement(react_1.Box, { position: 'relative', w: `${bigCircleDiameter}px`, h: `${blobHeight * 2}px`, flexShrink: 0 },
        react_2.default.createElement(react_1.Box, { position: 'absolute', top: `${smallCircleHeightOffset}px`, left: `${smallCircleWidthOffset}px`, style: {
                width: `${diameter}px`,
                height: `${diameter}px`,
                backgroundColor: props.color,
                borderRadius: `${smallCircleRadius}px`,
                zIndex: 10,
            } }),
        props.sides.showShadow && (react_2.default.createElement(react_1.Box, { position: 'absolute', top: `${bigCircleHeightOffset}px`, left: '0px', style: {
                width: `${bigCircleDiameter}px`,
                height: `${bigCircleDiameter}px`,
                backgroundColor: props.shadowColor,
                borderRadius: `${bigCircleRadius}px`,
                zIndex: 9,
            } })),
        lines));
};
const UiKitProgressBlobWithText = (props) => {
    const isInProgress = props.status === 'in progress';
    const isTodo = props.status === 'todo';
    const colorBlue = consistency_1.consistency.primaryBlue50;
    const shadowColorBlue = consistency_1.consistency.primaryBlue10;
    const colorYellow = consistency_1.consistency.warning70;
    const shadowColorYellow = consistency_1.consistency.warning20;
    const colorGray = consistency_1.consistency.gray20;
    const textColorGray = consistency_1.consistency.gray50;
    const textColorDarkGray = consistency_1.consistency.gray90;
    return (react_2.default.createElement(react_1.HStack, { spacing: consistency_1.consistency.halfBuffer, align: 'center' },
        react_2.default.createElement(UiKitBlob, { key: 'blob', outerRadius: props.outerRadius, innerRadius: props.innerRadius, textHeight: props.lines * 20, sides: {
                showShadow: isInProgress,
                direction: 'vertical',
                prevLineColor: props.lineShowTop ? props.prevLineColor : 'transparent',
                nextLineColor: props.lineShowBottom ? props.nextLineColor : 'transparent',
                lineThickness: 2,
            }, color: (isTodo && colorGray) || (props.isYellow && isInProgress && colorYellow) || colorBlue, shadowColor: (props.isYellow && shadowColorYellow) || shadowColorBlue }),
        react_2.default.createElement(UiKitTextClickable, { key: 'text', text: props.text, onClick: () => {
                props.onTextClick();
            }, title: `View Step: ${props.text}`, color: (isTodo && textColorGray) || (props.isYellow && isInProgress && colorYellow) || textColorDarkGray }),
        ";"));
};
const UiKitProgressLine = (props) => {
    return (react_2.default.createElement("div", { style: {
            flex: 1,
            height: `${props.height}px`,
            background: props.isDashedLine
                ? `repeating-linear-gradient(90deg, ${props.color}, ${props.color} 8px, transparent 8px, transparent 12px)`
                : props.color,
        } }));
};
const UiKitProgressBarVertical = (props) => {
    const items = [];
    const blobOuterRadius = 12;
    const blobInnerRadius = 4;
    props.items.forEach((item, index) => {
        const tagText = item.tag;
        const lineColorDarkBlue = consistency_1.consistency.primaryBlue50;
        const lineColorBlue = consistency_1.consistency.primaryBlue20;
        const lineColorYellow = consistency_1.consistency.warning50;
        const lineColorGray = consistency_1.consistency.gray20;
        const lineColor = (item.status === 'success outline' && lineColorDarkBlue) ||
            (item.status === 'in progress' &&
                tagText &&
                `repeating-linear-gradient(
          0deg,
          transparent,
          transparent 3px,
          ${lineColorYellow} 3px,
          ${lineColorYellow} 8px)`) ||
            (item.status === 'in progress' &&
                `repeating-linear-gradient(
          0deg,
          transparent,
          transparent 3px,
          ${lineColorBlue} 3px,
          ${lineColorBlue} 8px)`) ||
            lineColorGray;
        const prevLineColor = (item.status === 'todo' && lineColorGray) || lineColorDarkBlue;
        const isNotFirst = index !== 0;
        const isNotLast = index !== props.items.length - 1;
        const isNextUp = props.items.findIndex(item => item.status === 'in progress') === index - 1;
        const verticalLine = (react_2.default.createElement(react_1.VStack, { key: 'vertical-line', style: {
                height: '40px',
                width: '2px',
                marginLeft: '11px',
                marginBottom: '0px',
                background: lineColor,
            } }));
        items.push(react_2.default.createElement(UiKitProgressBlobWithText, { key: `${index}-item`, text: item.label, onTextClick: item.onClick, status: item.status, outerRadius: blobOuterRadius, innerRadius: blobInnerRadius, lines: item.label.length >= 35 ? 2 : 1, lineShowBottom: isNotLast, lineShowTop: isNotFirst, prevLineColor: isNextUp ? (props.items[index - 1].tag ? lineColorYellow : lineColorBlue) : prevLineColor, nextLineColor: lineColor, isYellow: !!tagText }));
        items.push(react_2.default.createElement(react_1.HStack, { key: `${index}-vertical-line-and-possibly-tag`, align: 'flex-start' },
            isNotLast && verticalLine,
            tagText && (react_2.default.createElement(react_1.HStack, { key: 'tag', padding: `2px 0 0 ${isNotLast ? 14 : 35}px` },
                react_2.default.createElement(exports.UiKitBase.Tag.Warning, { isSmall: true, showIcon: true, text: tagText })))));
    });
    return (react_2.default.createElement(react_1.VStack, { spacing: 0, align: 'stretch' }, items));
};
const UiKitProgressBarHorizontal = (props) => {
    const blobElements = [];
    const labelElements = [];
    const subtextLabelElements = [];
    const colorBlue = consistency_1.consistency.primaryBlue50;
    const lineColorBlue = consistency_1.consistency.primaryBlue20;
    const shadowColorBlue = consistency_1.consistency.primaryBlue10;
    const colorYellow = consistency_1.consistency.warning70;
    const lineColorYellow = consistency_1.consistency.warning50;
    const shadowColorYellow = consistency_1.consistency.warning20;
    const colorGray = consistency_1.consistency.gray10;
    const textColorGray = consistency_1.consistency.gray50;
    const textColorDarkGray = consistency_1.consistency.gray90;
    const outerRadius = props.blobRadius ?? 16;
    const innerRadius = props.blobRadius ? props.blobRadius - 10 : 6;
    const lineHeight = props.lineHeight ?? 2;
    const halfLabelWidth = props.isFullWidth ? 100 : 50;
    for (let blobsAdded = 0; blobsAdded < props.numberOfBlobs; blobsAdded++) {
        const blobNumber = blobsAdded + 1;
        const nextBlobNumber = blobNumber + 1;
        const lineColor = (nextBlobNumber <= props.numberOfBlobsCompleted && colorBlue) ||
            (props.showYellowLines && nextBlobNumber === props.numberOfBlobsCompleted + 1 && lineColorYellow) ||
            (nextBlobNumber === props.numberOfBlobsCompleted + 1 && lineColorBlue) ||
            colorGray;
        const textColor = (nextBlobNumber <= props.numberOfBlobsCompleted && textColorDarkGray) ||
            (props.showYellowLines && nextBlobNumber === props.numberOfBlobsCompleted + 1 && colorYellow) ||
            (nextBlobNumber === props.numberOfBlobsCompleted + 1 && colorBlue) ||
            textColorGray;
        const nextLineColor = nextBlobNumber <= props.numberOfBlobsCompleted ? colorBlue : colorGray;
        const prevLineColor = (nextBlobNumber <= props.numberOfBlobsCompleted && colorBlue) ||
            (nextBlobNumber === props.numberOfBlobsCompleted + 2 &&
                (props.showYellowLines ? lineColorYellow : lineColorBlue)) ||
            colorGray;
        blobElements.push(react_2.default.createElement(UiKitBlob, { key: `blob-${blobNumber}`, innerRadius: innerRadius, outerRadius: outerRadius, sides: {
                showShadow: blobNumber === props.numberOfBlobsCompleted,
                direction: 'horizontal',
                prevLineColor: blobsAdded !== 0 ? prevLineColor : 'transparent',
                nextLineColor: blobsAdded !== props.numberOfBlobs - 1 ? nextLineColor : 'transparent',
                lineThickness: lineHeight,
            }, color: blobNumber <= props.numberOfBlobsCompleted
                ? props.showYellowLines
                    ? colorYellow
                    : colorBlue
                : colorGray, shadowColor: blobNumber <= props.numberOfBlobsCompleted
                ? props.showYellowLines
                    ? shadowColorYellow
                    : shadowColorBlue
                : colorGray }));
        if (props.labels) {
            const label = props.labels[blobsAdded];
            labelElements.push(react_2.default.createElement(react_1.VStack, { align: 'center', key: label.text, w: `${2 * halfLabelWidth}px` },
                react_2.default.createElement(UiKitTextClickable, { text: label.text, onClick: label.onClick, color: textColor })));
            if (label.subtext) {
                subtextLabelElements.push(react_2.default.createElement(react_1.VStack, { align: 'center', key: label.subtext, w: `${2 * halfLabelWidth}px` },
                    react_2.default.createElement(UiKitTextBodySmall, { color: textColor }, label.subtext)));
            }
        }
        if (blobsAdded !== props.numberOfBlobs - 1) {
            blobElements.push(react_2.default.createElement(UiKitProgressLine, { height: lineHeight, color: lineColor, isDashedLine: nextBlobNumber === props.numberOfBlobsCompleted + 1, key: `line-${blobNumber}` }));
            if (props.labels) {
                labelElements.push(react_2.default.createElement(UiKitProgressLine, { height: lineHeight, color: 'transparent', isDashedLine: false, key: `line-${labelElements.length + 1}` }));
                if (props.labels.some(label => label.subtext)) {
                    subtextLabelElements.push(react_2.default.createElement(UiKitProgressLine, { height: lineHeight, color: 'transparent', isDashedLine: false, key: `line-${subtextLabelElements.length + 1}` }));
                }
            }
        }
    }
    const blobElementsHorizontalPadding = halfLabelWidth - outerRadius;
    const widthFromLines = (props.numberOfBlobs - 1) * 100;
    const widthFromBlobs = outerRadius * 2 * props.numberOfBlobs;
    const widthFromMargin = 2 * blobElementsHorizontalPadding;
    const containerWidth = widthFromLines + widthFromBlobs + (props.labels ? widthFromMargin : 0);
    return (react_2.default.createElement(react_1.VStack, { align: 'stretch', spacing: consistency_1.consistency.buffer, w: props.isFullWidth ? undefined : `${containerWidth}px` },
        props.labels ? (react_2.default.createElement(react_1.HStack, { align: 'center', spacing: 0 }, labelElements)) : (react_2.default.createElement(react_2.default.Fragment, null)),
        react_2.default.createElement(react_1.HStack, { align: 'center', spacing: 0, padding: props.labels ? `0 ${blobElementsHorizontalPadding}px` : 0 }, blobElements),
        props.labels && props.labels.some(label => label.subtext) && (react_2.default.createElement(react_1.HStack, { align: 'center', spacing: 0 }, subtextLabelElements))));
};
const YesNoCircle = (props) => (react_2.default.createElement(react_1.Box, null,
    react_2.default.createElement(react_1.CircularProgress, { size: '55px', max: 1, value: props.done ? 1 : 0, color: consistency_1.consistency.primaryBlue50 },
        react_2.default.createElement(react_1.CircularProgressLabel, { p: 0 }, props.done ? 'Yes' : 'No'))));
const FractionCircle = (props) => (react_2.default.createElement(react_1.Box, null,
    react_2.default.createElement(react_1.CircularProgress, { size: '55px', max: props.ofMax, value: props.completed, color: consistency_1.consistency.primaryBlue50 },
        react_2.default.createElement(react_1.CircularProgressLabel, { p: 0 }, `${props.completed} / ${props.ofMax}`))));
exports.UiKitBase = {
    Function: UiKitFunctions_1.Functions,
    navigation: UiKitNavigation_1.navigation,
    consistency: consistency_1.consistency,
    commonStrings: {
        chooseFile: 'Choose File',
        cancel: 'Cancel',
        save: 'Save',
        edit: 'Edit',
        close: 'Close',
        view: 'View',
        request: 'Request',
        done: 'Done',
        confirm: 'Confirm',
        create: 'Create',
    },
    Text: {
        Normal: UiKitTextBodyRegular,
        BodyLarge: UiKitTextBodyLarge,
        BodyLargeWithBackground: UiKitTextBodyLargeWithBackground,
        BodyRegular: UiKitTextBodyRegular,
        BodyRegularBold: UiKitTextBodyRegularBold,
        BodySemiBold: UiKitTextBodySemiBold,
        BodySmall: UiKitTextBodySmall,
        BodyExtraSmall: UiKitTextBodyExtraSmall,
        Clickable: UiKitTextClickable,
        StatusIconAndText: UiKitTextStatusIconAndText,
        Heading1: createUiKitHeading('28px', '40px', '400'),
        Heading2: createUiKitHeading('24px', '30px', '500'),
        Heading3: createUiKitHeading('18px', '22px', '400'),
        Heading4: createUiKitHeading('15px', '22px', '400'),
        Heading5: createUiKitHeading('17px', '20px', '600'),
        Heading6: createUiKitHeading('12px', '16px', '700'),
        Heading7: createUiKitHeading('18px', '22px', '600'),
        Heading8: createUiKitHeading('11px', '12px', '700'),
        Heading9: createUiKitHeading('20px', '26px', '500'),
        Heading10: createUiKitHeading('32px', '40px', '400'),
        DashDash: UiKitTextDashDash,
        NumberInACircle: UiKitTabs_1.UiKitNumberInACircle,
        NumberInACircleThenText: UiKitNumberInACircleThenText,
        ExternalLink: UiKitTextClickableExternalLink,
        InactiveLink: UiKitTextInactiveLink,
        Breadcrumb: UiKitTextBreadcrumb,
    },
    ItemNumberBadge: UiKitItemsNumberBadge,
    InfoBox: UiKitInfoBox,
    BoxWithHeader: UiKitBoxWithHeader,
    Tabs: UiKitTabs_1.UiKitTabs,
    TabsLabelsOnly: UiKitTabs_1.UiKitTabsLabelsOnly,
    Collapsible: exports.UiKitCollapsible,
    Button: {
        Primary: UiKitButton_1.UiKitButtonPrimary,
        Secondary: UiKitButton_1.UiKitButtonSecondary,
        Tertiary: UiKitButton_1.UiKitButtonTertiary,
        Danger: UiKitButton_1.UiKitButtonDanger,
        DangerBorderless: UiKitButton_1.UiKitButtonDangerBorderless,
        Cancel: UiKitButton_1.UiKitButtonCancel,
        TopBar: UiKitButton_1.UiKitButtonTopBar,
    },
    Tag: {
        Beta: UiKitTagBeta,
        New: UiKitTagNew,
        Custom: UiKitTag,
        Success: (props) => (react_2.default.createElement(UiKitTagForStatus, { status: 'success', text: props.text, showIcon: props.showIcon, isClosable: props.isClosable, onCloseClick: props.onCloseClick, isSmall: props.isSmall })),
        Error: (props) => (react_2.default.createElement(UiKitTagForStatus, { status: 'error', text: props.text, showIcon: props.showIcon, isClosable: props.isClosable, onCloseClick: props.onCloseClick, isSmall: props.isSmall })),
        Warning: (props) => (react_2.default.createElement(UiKitTagForStatus, { status: 'warning', text: props.text, showIcon: props.showIcon, isClosable: props.isClosable, onCloseClick: props.onCloseClick, isSmall: props.isSmall })),
        Info: (props) => (react_2.default.createElement(UiKitTagForStatus, { status: 'info', text: props.text, showIcon: props.showIcon, isClosable: props.isClosable, onCloseClick: props.onCloseClick, isSmall: props.isSmall })),
        Neutral: (props) => (react_2.default.createElement(UiKitTagForStatus, { status: 'neutral', text: props.text, showIcon: props.showIcon, isClosable: props.isClosable, onCloseClick: props.onCloseClick, isSmall: props.isSmall })),
    },
    Hint: {
        Tip: (props) => UiKitHintForStatus('tip', props),
        Question: (props) => UiKitHintForStatus('question', props),
        InProgress: (props) => UiKitHintForStatus('in progress', props),
        Info: (props) => UiKitHintForStatus('info', props),
        InfoOutline: (props) => UiKitHintForStatus('info outline', props),
        Warning: (props) => UiKitHintForStatus('warning', props),
        WarningOutline: (props) => UiKitHintForStatus('warning outline', props),
        Success: (props) => UiKitHintForStatus('success', props),
        SuccessOutline: (props) => UiKitHintForStatus('success outline', props),
        Error: (props) => UiKitHintForStatus('error', props),
        ErrorOutline: (props) => UiKitHintForStatus('error outline', props),
        Neutral: (props) => UiKitHintForStatus('neutral', props),
    },
    Form: {
        Date: UiKitDatePicker_1.UiKitDatePicker,
        DateInput: UiKitDatePicker_1.UiKitDatePickerInput,
        Row: UiKitFormRow,
        InputLabel: UiKitInputLabel,
        Input: UiKitInput_1.UiKitInput,
        InputArea: UiKitInputArea,
        Select: UiKitSelect_1.UiKitSelect,
        Label: UiKitFormLabel,
        LabelLeft: exports.UiKitFormLabelLeft,
        Checkbox: UiKitFormCheckbox,
        Toggle: UiKitFormToggle,
        RadioGroup: UiKitFormRadioGroup,
        Number: UiKitFormNumber,
    },
    DotsMenu: UiKitDotsMenu,
    MenuTertiary: UiKitMenuTertiary,
    Menu: UiKitMenu,
    Nav: UiKitNav_1.UiKitNav,
    TableHeader: UiKitTableHeader,
    TableRow: UiKitTableRow,
    Table: UiKitTable,
    Tooltip: exports.UiKitTooltip,
    WrapWithTooltip: UiKitWrapWithTooltip,
    Spinner: UiKitSpinner,
    SpinnerWithText: UiKitSpinnerWithText,
    Icon: UiKitIcon,
    Page: UiKitPage,
    Modal: UiKitModal,
    FilterWithMagnifier: UiKitFilterWithMagnifier,
    Progress: {
        Vertical: UiKitProgressBarVertical,
        Horizontal: UiKitProgressBarHorizontal,
        YesNoCircle: YesNoCircle,
        FractionCircle: FractionCircle,
    },
};
